import { render } from "./Event.vue?vue&type=template&id=5a9beb54&scoped=true"
import script from "./Event.vue?vue&type=script&lang=ts"
export * from "./Event.vue?vue&type=script&lang=ts"

import "./Event.vue?vue&type=style&index=0&id=5a9beb54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a9beb54"

export default script